import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import CommonRoomResponsive from './CommonRoomResponsive/CommonRoomResponsive.container';
import type { CommonRoomView } from './CommonRoomResponsive/types';
import PostsTableToggle from './PostsTableToggle';
import ScheduledPostsToggle from './ScheduledPostsToggle';

interface CommonRoomToggleProps {
  view?: CommonRoomView;
  [key: string]: any;
}

const CommonRoomToggle = ({
  view = 'feed',
  ...props
}: CommonRoomToggleProps) => {
  const { webAppFtResponsiveCommonRoom202609 } = useFlags();

  if (webAppFtResponsiveCommonRoom202609) {
    return <CommonRoomResponsive {...props} view={view} />;
  }

  if (view === 'scheduled') {
    return <ScheduledPostsToggle {...props} />;
  }

  return <PostsTableToggle {...props} />;
};

export const CommonRoomScheduledToggle = (props: CommonRoomToggleProps) => (
  <CommonRoomToggle {...props} view="scheduled" />
);

export default CommonRoomToggle;
